import { getTraceData } from "@sentry/react";
import type { Middleware } from "openapi-fetch";

export const sentryMiddleware: Middleware = {
  onRequest: ({ request }: { request: Request }) => {
    const traceData = getTraceData();
    const sentryTraceHeader = traceData["sentry-trace"];
    const sentryBaggageHeader = traceData["baggage"];

    if (sentryTraceHeader) {
      request.headers.set("sentry-trace", sentryTraceHeader);
    }

    if (sentryBaggageHeader) {
      request.headers.set("baggage", sentryBaggageHeader);
    }

    return request;
  }
};
